import { useMemo } from "react"

import { cn } from "@/lib/utils"

import NavbarSection from "./NavbarSection"
import useRoutes from "./useRoutes"
import { visibleNavNodes } from "./utils"

interface NavbarProps {
  isNavbarCollapsed: boolean
}

const Navbar = ({ isNavbarCollapsed }: NavbarProps) => {
  const allRoutes = useRoutes()
  // The one place hidden items are dropped: the desktop sidebar and the mobile drawer both render
  // <Navbar>, and the sections below (accordions, active state, stagger) only ever see visible nodes.
  const routes = useMemo(
    () =>
      allRoutes
        .map((section) => ({ ...section, children: visibleNavNodes(section.children) }))
        .filter((section) => section.children.length > 0),
    [allRoutes],
  )

  let countOffset = 0

  return (
    <aside
      className={cn(
        "flex min-h-0 shrink-0 flex-col transition-all duration-300",
        isNavbarCollapsed ? "w-[80px]" : "w-[250px]",
      )}
    >
      <nav
        className={cn(
          "flex-1 overflow-y-auto overflow-x-hidden transition-all duration-300",
          isNavbarCollapsed ? "px-2 pt-2" : "px-4 pt-4",
        )}
      >
        {routes.map((navbarSection, i) => {
          const section = (
            <NavbarSection
              key={navbarSection.heading}
              heading={navbarSection.heading}
              collapsedHeading={navbarSection.collapsedHeading}
              nodes={navbarSection.children}
              isBordered={!!i}
              isNavbarCollapsed={isNavbarCollapsed}
              countOffset={countOffset}
            />
          )
          countOffset += navbarSection.children.length
          return section
        })}
      </nav>
    </aside>
  )
}

export default Navbar
